import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { subscribeToCircle, subscribeToUserCircles } from '../services/circleService';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

const ACTIVE_CIRCLE_KEY = 'artpingpong_active_circle';

export function useCircle() {
  const { currentUser } = useAuth();
  const [circles, setCircles] = useState([]);
  const [currentCircle, setCurrentCircle] = useState(null);
  const [circleIds, setCircleIds] = useState([]);
  const [circleIdsLoaded, setCircleIdsLoaded] = useState(false);
  const [pinnedCircles, setPinnedCircles] = useState([]);
  const [activeCircleId, setActiveCircleId] = useState(
    () => localStorage.getItem(ACTIVE_CIRCLE_KEY) || null
  );

  useEffect(() => {
    if (!currentUser?.uid) {
      setCircleIds([]);
      setPinnedCircles([]);
      setCircleIdsLoaded(true);
      return;
    }
    setCircleIdsLoaded(false);
    return onSnapshot(doc(db, 'users', currentUser.uid), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        const ids = data.circleIds || [];
        const legacy = data.circleId ? [data.circleId] : [];
        setCircleIds([...new Set([...legacy, ...ids])]);
        setPinnedCircles(data.pinnedCircles || []);
      }
      setCircleIdsLoaded(true);
    });
  }, [currentUser?.uid]);

  useEffect(() => {
    if (!circleIds.length) {
      setCircles([]);
      setCurrentCircle(null);
      return;
    }
    return subscribeToUserCircles(circleIds, setCircles);
  }, [JSON.stringify(circleIds)]);

  useEffect(() => {
    const targetId = activeCircleId || circleIds[0];
    if (!targetId) return;
    return subscribeToCircle(targetId, setCurrentCircle);
  }, [activeCircleId, JSON.stringify(circleIds)]);

  const selectCircle = useCallback((circleId) => {
    setActiveCircleId(circleId);
    localStorage.setItem(ACTIVE_CIRCLE_KEY, circleId);
  }, []);

  return {
    circles,
    currentCircle,
    activeCircleId: activeCircleId || circleIds[0] || null,
    selectCircle,
    hasCircles: circleIds.length > 0,
    circlesLoading: !circleIdsLoaded,
    pinnedCircles,
  };
}
